import React from 'react';
import { Text, } from 'react-native';
import Utilities from '../~Utilities/Utilities';

//Id = 0;

export default class Text2 extends React.Component 
 {

   bTimer      = false;
   iFreq       = 1000; //millisecond
   iTick_Count = parseInt((1000/1000).toFixed());
   oTimer;
   iSecs = 0;
   //sNewS = {val:""};

   stopTimer()
   {
     if (this.bTimer == true)
       {
       Utilities.Sendlog("Stopped Text2 timer, freq: " + this.iFreq);
       clearInterval(this.oTimer);
       this.bTimer = false;
       }
   }
   
    startTimer(event)
   {
     if (this.bTimer == false)
     {
      this.oTimer = setInterval(event, this.iFreq);
   
     Utilities.Sendlog("Started Text2 timer, freq: " + this.iFreq);
     this.bTimer = true;
     }
   }

   
   
    UpdateData()
   {
    var sNewS1 = this.props.ggg();

    if (this.state.myState != sNewS1)
        {
        //this.state.myState = sNewS;
        //this.sNewS.val = sNewS1;
        //this.useNativePropsToUpdate1();

        this.setState({myState: sNewS1});
        }

      //console.log("Text2 time " + this.props.name);
      //this.updateState();
      //this.setState({myState: /*this.props.name + " " + */ this.props.ggg()});
      //this.iSecs++;

      //if (this.iSecs == 5)
      //  this.stopTimer();
   
   //    if (this.iSecs > 5 * this.iTick_Count)
   //       {
   //          this.iSecs = 0;
   //       }
   
   //   if (this.bTimer == true)
   //       {
   //        this.updateState();  
   //         //oFire();
   //       }
   }

   useNativePropsToUpdate()
   {
     this._MyComponent.setNativeProps({text: new Date().getSeconds().toString()});
   }  
   
    constructor(props)
    {
    super(props);
    //this.updateState1 = this.updateState.bind(this);

    //this.useNativePropsToUpdate1 = this.useNativePropsToUpdate.bind(this);
    this.UpdateData1 = this.UpdateData.bind(this);
    //this.ggg1 = this.props.ggg.bind(this);

    //this.stopTimer1 = this.stopTimer.bind(this);
    //this.startTimer1 = this.startTimer.bind(this);
    
   // console.log("Text2 ctor..." + this.props.name);
    //this.startTimer(this.UpdateData1);

    //this.UpdateData1();
    }


    componentDidMount() 
    {

      //console.log("Text2 mount...");
      this.props.bbb(this.UpdateData1, true);
    }

    //  updateState() 
    //  {
    //    this.state.myState = this.props.name + " " + new Date().getSeconds().toString();
    //  }

    componentWillUnmount() 
    {
      //console.log("Text2 un-mount...");
      this.props.bbb(this.UpdateData1, false);
    }
    
    
   state = {
      myState: ""
   }

   render() 
     {
      return (
        // <TextInput style={this.props.style} editable={false} ref={component=> this._MyComponent=component}></TextInput>
       <Text style={this.props.style}>{this.state.myState}</Text>
      );
   }
}